import { i18n } from 'i18next'
import { AuthState } from './authState'
import { LoginFlowStyle } from './style'

export function getClassName<style>(
  options: { style?: style } | undefined,
  className: keyof style,
  notset: string = ''
): string {
  return String(
    options && options.style && options.style[className]
      ? options.style[className]
      : notset
  )
}

export function isLoggedIn(authState: AuthState): boolean {
  return authState.status === 'logged in'
}

export function isLoggedOut(authState: AuthState): boolean {
  return authState.status === 'logged out'
}

export function isVerifyAuthentification(authState: AuthState): boolean {
  return authState.status === 'verify authentication'
}

export interface options {
  style?: LoginFlowStyle
  key?: string
}

export const isValidEmail = (email: string) =>
  /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/.test(
    email
  )
